import { type AddressEntity } from "commonComponents/entity/address/Address/Address.api.types";
import { type Email } from "commonComponents/entity/email/InputEmail/InputEmail.types";

import { type ContactEntity } from "entity/contact/Contact/Contact.api.types";

interface IContactInfo {
    address?: AddressEntity | string;
    cell?: string;
    primaryEmail?: Email;
    additionalEmails?: Email[];
    fax?: string;
    name?: string;
    displayName?: string;
    phone?: string;
}

export class ContactInfo implements IContactInfo {
    constructor(data: IContactInfo) {
        this.address = data.address;
        this.cell = data.cell;
        this.primaryEmail = data.primaryEmail;
        this.additionalEmails = data.additionalEmails;
        this.fax = data.fax;
        this.name = data.name;
        this.displayName = data.displayName;
        this.phone = data.phone;
    }

    /** address string is assumed to be raw HTML */
    address?: AddressEntity | string;
    cell?: string;
    primaryEmail?: Email;
    additionalEmails?: Email[];
    fax?: string;
    name?: string;
    displayName?: string;
    phone?: string;

    public static fromEntity(contact: ContactEntity) {
        return new ContactInfo({
            name: this.formatName(contact),
            displayName: contact.displayName,
            address: contact.address,
            phone: contact.phonePrimary,
            cell: contact.phoneCell,
            primaryEmail: contact.primaryEmail ?? undefined,
            additionalEmails: contact.additionalEmails,
        });
    }

    private static formatName = (contact: ContactEntity) => {
        let name = contact.firstName || contact.lastName ? "" : undefined;
        if (contact.firstName) {
            name += contact.firstName;
        }
        if (contact.firstName && contact.lastName) {
            name += " ";
        }
        if (contact.lastName) {
            name += contact.lastName;
        }
        return name;
    };
}
